import { styled } from '@mui/material/styles'

const Row = styled('div')({
  display: 'flex',
  alignItems: 'center',
  paddingBottom: '5px',
})

export default Row
